// VENDORS 
import jQuery from 'jquery';

import 'bootstrap-loader/extractStyles';


// ----->

import './img';
import './mapbox';




		// When the user scrolls down 20px from the top of the document, slide down the navbar
		window.onscroll = function() {scrollFunction()};
		function scrollFunction() {
		  if (document.body.scrollTop > 30 || document.documentElement.scrollTop > 30) {
		    document.getElementById("menus").style.top = "0";
		  } else {
		    document.getElementById("menus").style.top = "-30px";
		  }
		}


		// tootlips
		$(function () {
		  $('[data-toggle="tooltip"]').tooltip()
		})



